import { BaseSearchParametersModel } from "../../../models/base-search-parameters.model";

import { SearchFiltersModel } from "./search-filters.model";

export class DirectorySearchParametersModel extends BaseSearchParametersModel {
    public templateId: string;
    // public filters: SearchFiltersModel;

    public categories: Array<string>;
    public areas: Array<string>;

    public postcode: string;
    public distance: string;
}
